// import Portfolio from "../../components/Portfolio";
import About from "./sections/about/About";
import Contact from "./sections/contact/Contact";
import Hero from "./sections/hero/Hero";
import Portfolio from "./sections/portfolio/Portfolio";
import Services from "./sections/services/Services";
import ServiceSelection from "./sections/serviceSelection/ServiceSelection";
import Testimonials from "./sections/testimonials/Testimonials";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location?.pathname === "/" && !location?.hash) {
      navigate("/#home");
    }
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location, navigate]);
  return (
    <>
      <Hero />
      <ServiceSelection />
      <About />
      <Portfolio />
      <Services />
      <Testimonials />
      <Contact />
    </>
  );
};

export default Home;
